"use client";

import { Flex, Icon } from "@chakra-ui/react";
import {
  HiOutlineCalendarDays,
  HiOutlineCreditCard,
  HiOutlineShieldCheck,
} from "react-icons/hi2";
import { Text } from "@/components/ui";
import { useThemeTokens } from "@/lib/theme/tokens";

const TRUST_ITEMS = [
  { icon: HiOutlineShieldCheck, label: "Secure access" },
  { icon: HiOutlineCalendarDays, label: "Classes & schedules" },
  { icon: HiOutlineCreditCard, label: "Easy payments" },
] as const;

interface PublicAuthTrustStripProps {
  variant?: "default" | "compact";
}

export function PublicAuthTrustStrip({ variant = "default" }: PublicAuthTrustStripProps) {
  const theme = useThemeTokens();
  const isCompact = variant === "compact";

  return (
    <Flex
      mt={isCompact ? { base: 4, md: 4 } : { base: 6, md: 8 }}
      pt={isCompact ? { base: 3, md: 3 } : { base: 5, md: 6 }}
      borderTopWidth="1px"
      borderColor={theme.borderGlass.subtle}
      gap={isCompact ? 2 : 3}
      flexWrap="wrap"
      justify="center"
    >
      {TRUST_ITEMS.map((item) => (
        <Flex
          key={item.label}
          align="center"
          gap={2}
          px={isCompact ? 2.5 : 3}
          py={isCompact ? 1.5 : 2}
          borderRadius="full"
          borderWidth="1px"
          borderColor={theme.borderGlass.default}
        >
          <Icon as={item.icon} boxSize="14px" color={theme.accent.primary} aria-hidden />
          <Text fontSize="xs" fontWeight="500" color={theme.text.secondary}>
            {item.label}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
}
